// extracted by mini-css-extract-plugin
module.exports = {"container":"FeedModal_container__3nYtv","flexCurt":"FeedModal_flexCurt__IJe_M","curt":"FeedModal_curt__34ejj"};